const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: "32px",
    border: "none",
    background: "transparent",
    pointerEvent: 'none',
    margin: "0 !important",

    "& .MuiAccordionDetails-root": {
      padding: 0,
    },
    "&::before": {
      content: "none"
    },
    "& h3 > *": {
      margin: "0 !important",
    },
    '&:hover:not(.Mui-disabled)': {
      cursor: 'default',
    },
    "& .MuiAccordionSummary-content": {
      cursor: 'default',
    },
    "& .MuiAccordionSummary-root": {
      minHeight: 'auto'
    },
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 32px',
    margin: "0 !important",
    "& .MuiAccordionSummary-content": {
      margin: "0 !important",
    },
    cursor: 'default',
  },

  headerContent: {
    display: 'flex',
    flexDirection: "row",
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  }
} as const

export default styles

